import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import { SERVICES, FEATURES } from '../mock';

const Services = () => {
  return (
    <>
      <PageHeader
        crumb="Services"
        title="Our Services"
        subtitle="Everything you need for a smooth move or clearance — under one trusted roof."
      />

      <section className="section">
        <div className="container-xl space-y-20">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Truck;
            const reverse = i % 2 === 1;
            return (
              <div key={s.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${reverse ? 'lg:[&>div:first-child]:order-2' : ''}`}>
                <div>
                  <img src={s.image} alt={s.title} className="rounded-xl w-full aspect-[4/3] object-cover shadow-md" loading="lazy" />
                </div>
                <div>
                  <div className="inline-flex items-center gap-2 bg-orange-50 text-[color:var(--mv-orange)] px-3 py-1.5 rounded-full text-xs font-bold tracking-wider uppercase">
                    <Icon className="w-4 h-4" /> Service {String(i + 1).padStart(2, '0')}
                  </div>
                  <h2 className="font-display text-4xl md:text-5xl font-extrabold text-[color:var(--mv-navy)] mt-3">{s.title}</h2>
                  <p className="text-slate-600 mt-3 text-lg">{s.short}</p>
                  <p className="text-slate-700 mt-4 leading-relaxed">{s.description}</p>
                  <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                    {['Fully insured', 'Fixed hourly rate', 'Same-day available', 'Friendly team'].map((b) => (
                      <li key={b} className="flex items-center gap-2 text-slate-700">
                        <CheckCircle2 className="w-5 h-5 text-[color:var(--mv-orange)]" /> {b}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-7 flex flex-wrap gap-3">
                    <Link to="/#quote" className="btn-primary">Get a quote <ArrowRight className="w-4 h-4" /></Link>
                    <Link to="/prices" className="btn-ghost-dark">View pricing</Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* features */}
      <section className="section bg-[color:var(--mv-sky)]">
        <div className="container-xl">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <div className="text-[color:var(--mv-orange)] font-bold tracking-[0.2em] text-xs uppercase mb-3">Why Move Van</div>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-[color:var(--mv-navy)]">The service you deserve</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FEATURES.map((f) => {
              const Icon = Icons[f.icon] || Icons.CheckCircle2;
              return (
                <div key={f.title} className="bg-white rounded-xl p-7 border border-slate-100 hover:-translate-y-1 hover:shadow-lg transition-all">
                  <div className="w-12 h-12 rounded-md bg-[color:var(--mv-navy)] text-white flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-display text-xl font-extrabold text-[color:var(--mv-navy)] mt-4">{f.title}</h3>
                  <p className="text-slate-600 mt-2 leading-relaxed">{f.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
